import PropTypes from 'prop-types'
import React from 'react'
import { LazyImage } from 'react-lazy-images'
import axios from '../axios'
import DirectoryEntryModel from '../Models/DirectoryEntryModel'

class DirectoryItem extends React.Component {
    /**
     * Render the output for a company or person.
     *
     * @param {object} data
     */
    renderPersonOutput(data) {
        if (!data) return null

        let agency = data[0]
        if (!agency.company && agency.person) {
            return agency.person
        }

        return agency.company
    }

    onClick(e) {
        if (!this.props.preventDefault) return

        e.preventDefault()
        this.props.onClick()
    }

    render() {
        let entry = this.props.entry

        let classes = ['directory-entry']
        if (!this.props.visible) classes.push('invisible')

        let baseURL = window.location.origin
        let baseNode = document.getElementsByTagName('base')
        if (baseNode.length) {
            baseURL = baseNode[0].href
        }

        // Remove trailing slash. Image URL begins with leading slash.
        baseURL = baseURL.replace(/\/$/, '')

        return (
            <div className={classes.join(' ')} itemScope itemType="http://schema.org/Product">
                <a href={entry.url} itemProp="url" onClick={e => this.onClick(e)}>
                    <div className="img">
                        <LazyImage
                            src={entry.primaryImage.small}
                            alt={entry.name}
                            debounceDurationMs={400}
                            placeholder={({ imageProps, ref }) => (
                                <div ref={ref} className="background unloaded" />
                            )}
                            actual={({ imageProps }) => (
                                <div
                                    className="background"
                                    style={{ backgroundImage: `url(${imageProps.src})` }}
                                />
                            )}
                        />
                        <meta itemProp="image" content={baseURL + entry.primaryImage.medium}></meta>
                    </div>

                    {(entry.launch_year || entry.location) && (
                        <p className="project-meta">
                            {entry.launch_year && (
                                <span className="launch-year">{entry.launch_year}</span>
                            )}
                            {entry.launch_year && entry.location && (
                                <span className="separator"> • </span>
                            )}
                            {entry.location && <span className="location">{entry.location}</span>}
                        </p>
                    )}

                    <h3 itemProp="name">{entry.name}</h3>

                    <div className="description">
                        <p itemProp="description">{entry.texts.title}</p>
                        <p>{this.renderPersonOutput(entry.associated.agency)}</p>
                    </div>
                </a>
            </div>
        )
    }
}

DirectoryItem.propTypes = {
    entry: PropTypes.instanceOf(DirectoryEntryModel).isRequired,
    visible: PropTypes.bool,
    onClick: PropTypes.func,
}

DirectoryItem.defaultProps = {
    onClick: () => {},
    visible: true,
}

export default DirectoryItem
